import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../panel/panel.jsx";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class CreateForm extends Component {
  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/recetas-electronicas/surtidas">
              Recetas Electrónicas
            </Link>
          </li>
          <li className="breadcrumb-item active">Surtir</li>
        </ol>
        <h1 className="page-header">Surtir receta</h1>

        <div className="row">
          <div className="col-lg-12">
            <Panel>
              <PanelBody>
                <form
                  style={{ margin: "2%" }}
                  // onSubmit={this.props.handleSubmit}
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="establecimiento">
                          Establecimiento: <span className="text-red">*</span>
                        </label>
                        {this.props.state.establecimientos &&
                        this.props.state.establecimientos.length > 0 ? (
                          <>
                            <Select
                              id="establecimiento"
                              name="establecimiento"
                              isMulti={false}
                              isClearable={false}
                              styles={colourStyles}
                              placeholder="Seleccione"
                              onChange={this.props.handleEstablecimientoChange}
                              value={
                                this.props.state.establecimiento !== null ||
                                this.props.state.establecimiento !== ""
                                  ? this.props.state.establecimiento
                                  : { label: "Seleccione", key: "0" }
                              }
                              theme="neutral40"
                              options={this.props.state.establecimientos}
                              getOptionLabel={(establecimiento) =>
                                `${establecimiento.razon_social} (${establecimiento.folio_establecimiento})`
                              }
                              getOptionValue={(establecimiento) =>
                                establecimiento.id
                              }
                              noOptionsMessage={() =>
                                "No se encontraron establecimientos"
                              }
                            />
                            <div
                              className="invalid-feedback"
                              style={{ display: "none" }}
                              id="establecimiento-error"
                            ></div>
                          </>
                        ) : (
                          <div className="form-control">N/A</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {this.props.state.establecimiento &&
                  Object.keys(this.props.state.establecimiento).length > 0 ? (
                    <>
                      <div className="row">
                        <div
                          className={
                            !this.props.state.receta_valida
                              ? "col-lg-10"
                              : "col-lg-12"
                          }
                        >
                          <div className="form-group">
                            <label htmlFor="folio_receta">
                              Folio receta:{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              onChange={this.props.handleFolioRecetaChange}
                              name="folio_receta"
                              autoComplete="off"
                              value={this.props.state.folio_receta}
                              className="form-control"
                              id="folio_receta"
                              placeholder="Ingrese folio de receta"
                            />
                            <div
                              className="invalid-feedback"
                              style={{ display: "none" }}
                              id="folio_receta-error"
                            ></div>
                          </div>
                        </div>
                        {!this.props.state.receta_valida ? (
                          <div
                            className="col-lg-2"
                            style={{ marginTop: "2em" }}
                          >
                            <div className="form-group">
                              <button
                                type="button"
                                title="Verificar receta"
                                className="btn bg-gradient-yellow btn-block"
                                onClick={this.props.verifyFolioReceta}
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {this.props.state.receta_valida ? (
                        <div className="row">
                          <div className="col-lg-5">
                            <div className="form-group">
                              <label htmlFor="producto_nombre_comercial">
                                Nombre comercial del producto:
                              </label>
                              <div className="form-control">
                                {this.props.state.receta
                                  .producto_nombre_comercial ?? "N/A"}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-5">
                            <div className="form-group">
                              <label htmlFor="producto_presentacion">
                                Presentación del producto:
                              </label>
                              <div className="form-control">
                                {this.props.state.receta
                                  .producto_presentacion ?? "N/A"}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2">
                            <div className="form-group">
                              <label htmlFor="producto_cantidad">
                                Cantidad recetada:
                              </label>
                              <div className="form-control">
                                {this.props.state.receta.cant_num ?? "N/A"}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {this.props.state.receta_valida ? (
                        <>
                          <div className="row">
                            <div
                              className={
                                this.props.state.producto_valido
                                  ? "col-lg-6"
                                  : "col-lg-10"
                              }
                            >
                              <div className="form-group">
                                <label htmlFor="lote">
                                  Lote: <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  onChange={this.props.handleCantidadLote}
                                  name="lote"
                                  value={this.props.state.cantidad_lote.lote}
                                  className="form-control"
                                  id="lote"
                                  placeholder="Ingrese lote"
                                />
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "none" }}
                                  id="lote-error"
                                ></div>
                              </div>
                            </div>

                            {this.props.state.producto_valido ? (
                              <div className="col-lg-4">
                                <div className="form-group">
                                  <label htmlFor="cantidad">
                                    Cantidad:{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    onChange={this.props.handleCantidadLote}
                                    name="cantidad"
                                    value={
                                      this.props.state.cantidad_lote.cantidad
                                    }
                                    className="form-control"
                                    id="cantidad"
                                    placeholder="Ingrese cantidad"
                                  />
                                  <div
                                    className="invalid-feedback"
                                    style={{ display: "none" }}
                                    id="cantidad-error"
                                  ></div>
                                </div>
                              </div>
                            ) : null}
                            <div
                              className="col-lg-2"
                              style={{ marginTop: "2em" }}
                            >
                              <div className="form-group">
                                {this.props.state.producto_valido ? (
                                  <button
                                    type="button"
                                    title="Añadir cantidad y lote"
                                    className="btn bg-gradient-blue btn-block"
                                    onClick={this.props.addCantidadLote}
                                  >
                                    <i className="fas fa-plus"></i>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    title="Verificar producto"
                                    className="btn bg-gradient-yellow btn-block"
                                    onClick={this.props.verifyProduct}
                                  >
                                    <i className="fas fa-search"></i>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>

                          {this.props.state.producto_valido ||
                          this.props.state.cantidades_lotes.length > 0 ? (
                            <>
                              <br />
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="table-responsive">
                                    <table className="table table-striped mb-0 table-hover">
                                      <thead>
                                        <tr>
                                          <th
                                            className="text-center"
                                            width="25%"
                                          >
                                            Lote
                                          </th>

                                          <th
                                            className="text-center"
                                            width="20%"
                                          >
                                            Fecha fabricación
                                          </th>
                                          <th
                                            className="text-center"
                                            width="20%"
                                          >
                                            Vencimiento
                                          </th>
                                          <th
                                            className="text-center"
                                            width="20%"
                                          >
                                            Cantidad
                                          </th>
                                          <th
                                            className="text-center"
                                            width="10%"
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.props.state.cantidades_lotes
                                          .length > 0 ? (
                                          this.props.state.cantidades_lotes.map(
                                            (obj, index) => (
                                              <tr key={index} id={"o" + index}>
                                                <td className="text-center">
                                                  {obj.lote}
                                                </td>

                                                <td className="text-center">
                                                  {obj.fecha_fabricacion}
                                                </td>
                                                <td className="text-center">
                                                  {obj.vencimiento_lote}
                                                </td>
                                                <td className="text-center">
                                                  {obj.cantidad}
                                                </td>
                                                <td className="text-center">
                                                  <button
                                                    title="Remover"
                                                    id={index}
                                                    onClick={
                                                      this.props
                                                        .removeCantidadLote
                                                    }
                                                    className="btn btn-warning d-block ml-4"
                                                  >
                                                    <i
                                                      id={index}
                                                      className="fas fa-trash"
                                                    ></i>
                                                  </button>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="5"
                                              className="text-center"
                                            >
                                              Sin cantidades ni lotes a mostrar
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </>
                      ) : null}

                      <hr />

                      <div className="row">
                        <div className="col-lg-12">
                          <button
                            onClick={this.props.handleSubmit}
                            className="btn btn-success btn-block"
                          >
                            Surtir
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateForm;
